import React, { useContext } from 'react'

 import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DateFilter from '../../Components/CommonComponent/Dropdown/DateFilter';
import { CommonContext } from '../../App';


export default function PLTabsButton() {
  const location = useLocation();
  const { t } = useTranslation();
  const { branchId, dateRange ,setDateRange} = useContext(CommonContext);
  const tabs = [
    { title: t("p/lStatement"), path: "statement" },
    { title: t("p/lUtilisation"), path: "utilisation" },

  ];

  return (
    <div>
      <header className="tabs-header bg-theme-webBackground sticky top-9 z-10 py-1 flex justify-between gap-3 ">
    <div className=''>
          {tabs.map((tab) => {
      const fullPath = `/reports/profit-loss/${tab.path}`;

      const isActive =
        (location.pathname === "/reports/profit-loss" && tab.path === "statement") ||
        location.pathname === fullPath;

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab no-underline mx-2 relative top-1 py-[3px]  rounded-1 h-7  text-sm  px-2 ${isActive
                 ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
            >
              {tab.title}
            </Link>
          );
        })}
    </div>
        <div>
           <DateFilter
            storageKey="profitLoss"
             customMode="range"
             availableFilters={[ "default","today", "custom"]}
             onChange={(r) => setDateRange({
            startDate: r.startDate,
            endDate: r.endDate
          })} />
        </div>

      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}


